const valueExistsInOptions = ({ state, props, path }) => {
  const options = state.get(`selectr.${props.namespace}.options`)
  const { value } = props
  const index = options.reduce((acc, option, index) => {
    if (value.toLowerCase() === option.label.toLowerCase()) {
      acc = index
    }
    return acc
  }, null)
  if (index === null) {
    return path.false()
  } else {
    return path.true({ index })
  }
}

valueExistsInOptions.displayName = 'valueExistsInOptions'
export default valueExistsInOptions
